import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import axios from "axios";
import { Spin } from "antd";
import { axiosErrorHandler } from "../../../../../swzutils";
import HelpLabel from "../../../components/HelpLabel";
import { ClockCircleOutlined } from "@ant-design/icons";
import ValOrDash from "../../../components/ValOrDash";
import { ElapsedMinutesFormat } from "../../../components/FormattersTS";
const AverageTimeAcrossAllSitesWidget = (props, exportedRef) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    // useEffect(() => {
    //     if (props.date) {
    //         refresh();
    //     }
    // }, [props.date]);
    const refresh = () => {
        loadAverageTimeAcrossAllSites();
    };
    const loadAverageTimeAcrossAllSites = () => {
        setLoading(true);
        axios.get(`/admin/v1/dashboard/average-time-across-all-sites/${props.date}`)
            .then(response => {
            setData(response.data);
        })
            .catch(error => {
            axiosErrorHandler(error);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: loading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-purple", children: _jsx(ClockCircleOutlined, {}) }), (!loading && data?.avgMinutesAcrossAllSites)
                    ? _jsx("h2", { className: "widget-value", children: _jsx(ElapsedMinutesFormat, { value: data.avgMinutesAcrossAllSites }) })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Average time on all saved locations", helpText: _jsx("p", { children: "The average time spent on site across all saved locations. The value is calculated using the time difference when a driver triggers the entry and exit geo fence of a saved location." }) }) }), data?.driverIdleEmailsSent != null && _jsxs(_Fragment, { children: [_jsx("div", { className: "widget-separator" }), _jsx("h2", { className: "widget-value", children: _jsx(ValOrDash, { val: data.driverIdleEmailsSent }) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Driver idle emails sent", helpText: _jsx("p", { children: "The count of driver idle advisory emails that have been sent for the selected date" }) }) })] })] }) }));
};
export default React.forwardRef(AverageTimeAcrossAllSitesWidget);
